export default __webpack_public_path__ + "static/Reel_Commercial_German_24-dcbfb49cfd89cbe9c33c0656856040c7.mp3";